import { dataCar } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCar = /*#__PURE__*/createIcon(dataCar)
export default IconCar
